import { Typography } from '@stern-ui/ui';

import accessPdLogo from '@/assets/logos/access-pd.svg';
import { WelcomeContentProps } from '@/types';

export const AccessPD = (props: WelcomeContentProps) => {
	const { hciName } = props;
	const liClass =
		'bg-[url(/src/assets/icons/check.svg)] bg-no-repeat pl-8 mb-4 [background-position:center_left]';
	return (
		<>
			<img src={accessPdLogo} alt='AccessPD' className='w-[126px] mb-8' />
			<Typography variant='main' className='text-secondaryTextDark pb-8'>
				Thank you for your interest in AccessPD
			</Typography>
			<Typography variant='bodyBig'>
				{hciName} and Cohort Science would like to offer you the opportunity to participate
				in AccessPD, a research study that collects health information directly from
				patients with Parkinson’s Disease (PD).
			</Typography>
			<ul className='my-8'>
				<li className={liClass}>
					Participation in AccessPD can be done entirely from your home via the use of a
					smartphone, tablet or computer.
				</li>
				<li className={liClass}>
					Participation does not require you to visit your healthcare provider, hospital
					or clinic.
				</li>
				<li className={liClass}>
					Studies like this help improve our understanding and progression of PD.
				</li>
				<li className={liClass}>
					Studies like this are crucial to the development of better treatments for PD.
				</li>
			</ul>
			<Typography variant='bodyBig'>
				For further information, please visit the{' '}
				<a href='https://www.accesspd.org/' target='_blank' rel='noreferrer'>
					AccessPD website
				</a>
				.
			</Typography>
		</>
	);
};
